import * as React from "react";
import {
  AlignVerticalBottomRounded,
  AlignVerticalCenterRounded,
  AlignVerticalTopRounded,
  FormatAlignCenterRounded,
  FormatAlignJustifyRounded,
  FormatAlignLeftRounded,
  FormatAlignRightRounded,
} from "@mui/icons-material";
import { MAIN_COLOR } from "../../constants/common/utils";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "./elements.settings";

export const X_FORM_GUI_FIELDS: TXGUISection = {
  Général: [
    {
      type: "toggle_option",
      name: "type",
      label: "Type de Formulaire",
      options: [
        { value: "contact-us", label: "Contactez-Nous" },
        { value: "newsletter", label: "News Letter" },
      ],
      defaultValue: "contact-us",
    },
    {
      type: "sizing",
      name: "gap",
      label: "Espacement",
      units: ["px", "em"],
      defaultValue: "15px",
    },
  ],
  Button: [
    {
      type: "color",
      name: "btnBgColor",
      label: "Couleur d'arriere plan",
      defaultValue: MAIN_COLOR,
    },
    {
      type: "text",
      name: "btnText",
      label: "Texte du Bouton",
      defaultValue: "SOUMETTRE",
    },
    {
      type: "sizing",
      name: "btnTextFontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
    {
      type: "color",
      name: "btnTextColor",
      label: "Couleur du texte",
      defaultValue: "#FFFFFF",
    },
    {
      type: "select_option",
      name: "btnTextFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 400,
    },
    {
      type: "sizing",
      name: "btnWidth",
      label: "Largeur",
    },
    {
      type: "sizing",
      name: "btnHeight",
      label: "Hauteur",
    },
    {
      type: "sides",
      name: "btnMargin",
      label: "Espace Externe (Margin)",
      units: ["px", "em", "%", "auto"],
    },
    {
      type: "radius",
      name: "btnRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
    },
    {
      type: "border",
      name: "btnBorder",
      label: "Bordure",
      units: ["px", "em"],
    },
  ],
  "Button (Survolé)": [
    {
      type: "color",
      name: "btnHoverTextColor",
      label: "Couleur du texte",
      defaultValue: "#FFFFFF",
    },
    {
      type: "color",
      name: "btnHoverBgColor",
      label: "Couleur d'arriere plan",
    },
    {
      type: "border",
      name: "btnHoverBorder",
      label: "Bordure",
      units: ["px", "em"],
    },
  ],
  Champs: [
    {
      type: "select_option",
      name: "inputDesign",
      label: "Designe",
      options: [
        // todo add this later
        // { value: "material-standard", label: "Material Standard" },
        // { value: "material-outlined", label: "Material Contour" },
        // { value: "material-filled", label: "Material Rempli" },
        { value: "inline", label: "Une Ligne" },
        { value: "block", label: "Normal" },
        { value: "no-label", label: "Sans Label" },
      ],
      defaultValue: 400,
    },
    {
      type: "sizing",
      name: "inputHeight",
      label: "Hauteur",
      defaultValue: "40px",
    },
    {
      type: "sizing",
      name: "inputTextFontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
    {
      type: "color",
      name: "inputTextColor",
      label: "Couleur du texte",
      defaultValue: "#000000",
    },
    {
      type: "select_option",
      name: "inputTextFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 400,
    },
    {
      type: "color",
      name: "inputBgColor",
      label: "Couleur d'arriere plan",
    },
    {
      type: "radius",
      name: "inputRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
    },
    {
      type: "border",
      name: "inputBorder",
      label: "Bordure",
      units: ["px", "em"],
      defaultValue: { color: "#000000", style: "solid", width: "1px" },
    },
  ],
  "Champs (Focus)": [
    {
      type: "color",
      name: "inputFocusBgColor",
      label: "Couleur d'arriere plan",
    },
    {
      type: "border",
      name: "inputFocusBorder",
      label: "Bordure",
      units: ["px", "em"],
    },
  ],
  "Titre des Champs": [
    {
      type: "toggle_option",
      name: "shrinkLabel",
      label: "Ouvert (Material)",
      options: [
        { value: false, label: "Non" },
        { value: true, label: "Oui" },
      ],
      defaultValue: false,
    },
    {
      type: "sizing",
      name: "labelFontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
    {
      type: "color",
      name: "labelColor",
      label: "Couleur du texte",
      defaultValue: "#000000",
    },
    {
      type: "select_option",
      name: "labelFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 400,
    },
    {
      type: "sizing",
      name: "labelWidth",
      label: "Largeur",
    },
    {
      type: "toggle_option",
      name: "labelTextAlign",
      label: "Alignement du texte",
      options: [
        { value: "left", label: "Gauche", icon: <FormatAlignLeftRounded /> },
        {
          value: "center",
          label: "Centre",
          icon: <FormatAlignCenterRounded />,
        },
        { value: "right", label: "Droite", icon: <FormatAlignRightRounded /> },
        {
          value: "justify",
          label: "Remplir",
          icon: <FormatAlignJustifyRounded />,
        },
      ],
      defaultValue: "left",
    },
    {
      type: "toggle_option",
      name: "labelVerticalAlign",
      label: "Alignement Vertical",
      options: [
        {
          value: "flex-start",
          label: "Haut",
          icon: <AlignVerticalTopRounded />,
        },
        {
          value: "center",
          label: "Centre",
          icon: <AlignVerticalCenterRounded />,
        },
        {
          value: "flex-end",
          label: "Bas",
          icon: <AlignVerticalBottomRounded />,
        },
      ],
      defaultValue: "flex-start",
    },
  ],

  ...ELEMENTS_GUI_FIELDS,
};
